import type { ApolloError } from "@apollo/client";
import getGraphQLErrorMessageForPresentation from "./graphQLErrorPresentation";

function getPrivateGraphQLError(error: ApolloError) {
  return error.graphQLErrors.find(
    (graphQLError) => graphQLError.extensions?.isUserFacing === false,
  );
}

function getPublicGraphQLErrors(error: ApolloError) {
  return error.graphQLErrors.filter(
    (graphQLError) => graphQLError.extensions?.isUserFacing !== false,
  );
}

export default function getApolloErrorMessages(error: ApolloError) {
  const publicGraphQLErrors = getPublicGraphQLErrors(error);

  if (publicGraphQLErrors.length) {
    return publicGraphQLErrors.map(getGraphQLErrorMessageForPresentation);
  }

  const privateGraphQLError = getPrivateGraphQLError(error);

  if (privateGraphQLError) {
    return [getGraphQLErrorMessageForPresentation(privateGraphQLError)];
  }

  return [error.message];
}

/**
 * Preserves Apollo's original message unless it mixes public and private
 * GraphQL errors. Mixed responses expose only the public messages, while a
 * fully private response produces one safe unexpected-error message.
 */
export function getApolloErrorPresentation(error: ApolloError) {
  const privateGraphQLError = getPrivateGraphQLError(error);

  if (!privateGraphQLError) {
    return error.message;
  }

  const publicGraphQLErrors = getPublicGraphQLErrors(error);

  return publicGraphQLErrors.length
    ? publicGraphQLErrors.map(getGraphQLErrorMessageForPresentation)
    : getGraphQLErrorMessageForPresentation(privateGraphQLError);
}
